<template>
  <div class="mallOrderList">
    <el-tabs
      v-model="orderStatus"
      class="orderListTabs"
      @tab-click="searchInfo"
    >
      <el-tab-pane
        v-for="item in tabList"
        :key="item.id"
        :label="item.name"
        :name="item.id"
      >
      </el-tab-pane>
    </el-tabs>
    <div>
      <div class="orderSearchBox">
        <div class="timeSearch">
          <span style="color: #b2b2b2">区间筛选</span>
          <el-date-picker
            @change="chooseDate"
            v-model="createDateValue"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <el-input v-model="goodsName" placeholder="商品名称"></el-input>
        <el-input v-model="storeName" placeholder="商家名称"></el-input>
        <el-input v-model="orderNo" placeholder="订单编号"></el-input>
        <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="clearSearch">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
      <div class="orderListTable">
        <ul class="tableHeader">
          <li class="name">商品信息</li>
          <li class="price">兑换积分数</li>
          <li class="activeName">活动名称</li>
          <li class="num">数量</li>
          <li class="payment">总积分</li>
          <li class="status">订单状态</li>
          <li class="operation">操作</li>
        </ul>
        <ul
          class="tableBody"
          v-if="printMessage.length != 0"
          v-loading="loading"
        >
          <li
            class="bodyItem"
            v-for="(printItems, index) in printMessage"
            :key="index"
          >
            <div class="itemTop">
              <div>订单编号：{{ printItems.orderBase.orderNo }}</div>
              <div>创建时间：{{ printItems.orderBase.createDate }}</div>
              <div class="merchantInfo">
                <div class="merchantInfo">
                  <span>商家：</span>
                  <span>{{ printItems.storeName }}</span>
                  <i
                    class="iconfont icon-weixin"
                    @click="startChat(printItems.enterPriseUuid)"
                  ></i>
                </div>
              </div>
            </div>
            <div class="itemBottom">
              <div class="name">
                <div
                  class="orderInfo"
                  v-for="(modelItems, modelIndex) in printItems.shopList"
                  :key="modelIndex"
                >
                  <img :src="modelItems.specUrl" alt="" />
                  <div class="infoContent">
                    <div class="infoName">
                      {{ modelItems.goodsName }}-{{ modelItems.specName }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="price">
                <div
                  v-for="(modelItems, modelIndex) in printItems.shopList"
                  :key="modelIndex"
                  style="padding: 50px"
                >
                {{ modelItems.price }}
                </div>
              </div>
              <div class="activeName">
                <div style="padding: 50px">
                  {{ printItems.orderBase.activityName }}
                </div>
              </div>
              <div class="num">
                <div
                  v-for="(modelItems, modelIndex) in printItems.shopList"
                  :key="modelIndex"
                  style="padding: 50px"
                  :class="printItems.shopList.length > 1 ? 'numborder' : ''"
                >
                  {{ modelItems.num }}
                </div>
              </div>
              <div class="payment">
                <h3>{{ printItems.orderBase.totalPrice }}</h3>
                <div class="title">
                  (含运费：{{
                    printItems.orderBase.transportationPrice == null
                      ? 0
                      : printItems.orderBase.transportationPrice
                  }}元)
                </div>
              </div>
              <div class="status">
                <div class="statusName">
                  {{ printItems.orderBase.orderStatusCn }}
                </div>
                <el-button
                  type="text"
                  class="operationBtn"
                  @click="goToDetail(printItems.orderBase.uuid)"
                  >订单详情
                </el-button>
              </div>
              <div class="operation">
                <el-button
                  type="text"
                  class="operationBtnMoney"
                  v-if="printItems.orderBase.orderStatus === 'UN_RECEIVE'"
                  @click="takeDelivery(printItems.orderBase)"
                  >确认收货</el-button
                >
                <el-button
                  type="text"
                  class="operationBtnMoney"
                  v-if="printItems.orderBase.orderStatus === 'UN_APPRAISE'"
                  @click="toEvaluate(printItems)"
                  >评价</el-button
                >
              </div>
            </div>
          </li>
        </ul>
        <div class="orderNomesaage" v-loading="loading" v-else>暂无数据</div>
      </div>
    </div>
    <el-pagination
      v-if="printMessage.length != 0"
      background
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
      layout="total,prev, pager, next,jumper"
      :page-size="pageSize"
      :total="total"
      class="pagination"
    >
    </el-pagination>
    <!--评价弹出框-->
    <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
      <div class="evaluateDialogBox">
        <div class="evaluateItem">
          <div class="name">评价等级</div>
          <div class="content">
            <div class="rateItem">
              <div class="name">描述相符</div>
              <el-rate
                v-model="evaluateForm.descriptionPoint"
                show-score
                text-color="#ff9900"
              >
              </el-rate>
            </div>
            <div class="rateItem">
              <div class="name">服务态度</div>
              <el-rate
                v-model="evaluateForm.servicePoint"
                show-score
                text-color="#ff9900"
              >
              </el-rate>
            </div>
            <div class="rateItem">
              <div class="name">专业程度</div>
              <el-rate
                v-model="evaluateForm.transportPoint"
                show-score
                text-color="#ff9900"
              >
              </el-rate>
            </div>
          </div>
        </div>
        <div class="evaluateItem">
          <div class="name">评价标签</div>
          <div class="content">
            <el-checkbox-group
              v-model="evaluateForm.evaluationTagList"
              class="evaluateTag"
            >
              <el-checkbox-button
                v-for="tag in tagList"
                :label="tag"
                :key="tag.tagUuid"
                >{{ tag.tagName }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </div>
        <div class="evaluateItem">
          <div class="name">评价内容</div>
          <div class="content">
            <el-input
              type="textarea"
              :autosize="{ minRows: 6 }"
              placeholder="请输入内容"
              v-model="evaluateForm.evaluationContent"
            >
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="evaluateDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="stepLoading"
          @click="evaluateSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
  </div>
</template>

<script>
import {
  getOrderShopList,
  getRongCloudUser,
  updateOrderShopBaseInfo,
  getDictionaryItem,
  saveEvaluation,
  offlinePay,
  deliveryOnCash,
} from "../../../utils/interface";
import chatDialog from "../../../components/chat/chatDialog";

export default {
  name: "mallOrderList",
  components: {
    chatDialog,
  },
  data() {
    return {
      stepLoading: false,
      loading: false,
      orderStatus: "ALL",
      tabList: [
        {
          id: "ALL",
          name: "全部",
        },
        {
          id: "UN_SEND",
          name: "待发货",
        },
        {
          id: "UN_RECEIVE",
          name: "待收货",
        },
        {
          id: "UN_APPRAISE",
          name: "待评价",
        },
          {
              id: "FINISHED",
              name: "完成",
          },
      ],
      createDateValue: null,
      startTime: "",
      endTime: "",
      goodsName: "",
      storeName: "",
      orderNo: "",
      orderStatusValue: "",
      evaluateStatusValue: "",
      postSalesServiceValue: "",
      //分页
      current: 1,
      total: 0,
      pageSize: 10,
      printMessage: [],
      //
      dialogFormVisible: false,
      form: {
        name: "",
        number: "",
        email: "",
      },
      formLabelWidth: "120px",
      dialogEvaluation: false,
      dialogEvaluation2: false,
      formEvaluation: {
        name: "",
        name2: "",
      },
      evaluationWidth: "120px",
      // 修改价格
      priceDialogVisible: false,
      orderBaseInfo: {},
      // 取消订单
      cancelDialogVisible: false,
      cancelList: [],
      cancelUuid: "",
      evaluateDialogVisible: false,
      evaluateForm: {
        descriptionPoint: 0,
        servicePoint: 0,
        transportPoint: 0,
        evaluationTagList: [],
        evaluationContent: "",
      },
      tagList: [],
      order: {},
    };
  },
  created() {
    this.getOrderShopList();
    this.getDictionaryItem();
  },
  methods: {
    // 获取字典值
    getDictionaryItem() {
      getDictionaryItem({ groupCode: "shop_evaluation_tag" }).then((res) => {
        this.tagList = [];
        res.forEach((item, index) => {
          this.tagList.push({
            tagName: item.name,
            tagUuid: item.code,
            tagGroupId: item.groupUuid,
          });
        });
      });
    },
    // 点击打开评价弹出框
    toEvaluate(order) {
      this.order = order;
      this.evaluateForm = {
        descriptionPoint: 0,
        servicePoint: 0,
        transportPoint: 0,
        evaluationTagList: [],
        evaluationContent: "",
      };
      this.evaluateDialogVisible = true;
    },
    // 评价提交
    evaluateSubmit() {
      this.stepLoading = true;
      if (
        this.evaluateForm.descriptionPoint &&
        this.evaluateForm.servicePoint &&
        this.evaluateForm.transportPoint
      ) {
        this.evaluateForm.orderNo = this.order.orderBase.orderNo;
        this.evaluateForm.orderUuid = this.order.orderBase.uuid;
        this.evaluateForm.orderType = "SHOP";
        this.evaluateForm.evaluationType = "NORMAL";
        this.evaluateForm.sellerName = this.order.storeName;
        this.evaluateForm.sellerUuid = this.order.enterPriseUuid;
        this.evaluateForm.orderName = this.order.goodsName;
        this.evaluateForm.orderAmount = this.order.orderBase.totalPrice;

        saveEvaluation(this.evaluateForm).then((response) => {
          if (response.success) {
            this.evaluateDialogVisible = false;
            this.getOrderShopList();
            this.$message({
              type: "success",
              message: "评价成功",
            });
          } else {
            this.$message({
              type: "error",
              message: response.message,
            });
          }
        });
      } else {
        this.$message.warning("请选择评价等级");
      }
      setTimeout(() => {
        this.stepLoading = false;
      }, 1000);
    },
    getOrderShopList() {
      let params = {
        orderType: "INTEGRAL",
        current: this.current,
        pageSize: this.pageSize,
        isBuy: true,
        goodsName: this.goodsName,
        orderNo: this.orderNo,
        storeName: this.storeName,
        startDate: this.startTime,
        endDate: this.endTime,
        orderStatus: this.orderStatus == "ALL" ? "" : this.orderStatus,
      };
      getOrderShopList(params).then((res) => {
        this.total = res.total;
        this.printMessage = res.list;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
      this.getOrderShopList();
    },
    // 时间格式
    chooseDate() {
      this.startTime = "";
      this.endTime = "";
      // 判断时间
      if (this.createDateValue != null && this.createDateValue.length == 2) {
        this.startTime = this.timeDate(this.createDateValue[0]);
        this.endTime = this.timeDate(this.createDateValue[1]);
      }
    },
    timeDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + MM + "-" + d;
    },
    goToDetail(orderBaseUuid) {
      this.$router.push({
        name: "integralOrderDetails",
        params: { orderBaseUuid: orderBaseUuid },
      });
    },
    // 通信
    startChat(targetUuid) {
      let user = this.$store.state.userMessages;
      getRongCloudUser(targetUuid).then((res) => {
        this.$refs.chatDialogRef.init(
          user.uuid,
          user.name,
          user.headUrl,
          res.uuid,
          res.name,
          res.headUrl
        );
      });
    },
    searchInfo() {
      this.current = 1;
      this.getOrderShopList();
    },
    clearSearch() {
      this.goodsName = "";
      this.orderNo = "";
      this.storeName = "";
      this.createDateValue = null;
      this.orderStatus = "ALL";
      this.startTime = "";
      this.endTime = "";
      this.searchInfo();
    },
    // 收货
    takeDelivery(item) {
      this.$confirm("是否确认收货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        item.orderStatus = "UN_APPRAISE";
        updateOrderShopBaseInfo(item).then((res) => {
          if (res.success) {
            this.$message.success("收货成功！");
            this.getOrderShopList();
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
.mallOrderList {
  padding: 94px 20px 20px;

  .orderListTabs {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    background: #fff;
    width: 100%;
    padding: 20px;
  }

  /deep/ .el-tabs__item {
    padding: 0 25px !important;
    text-align: center;

    &:hover {
      color: #3686d7;
    }

    &:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 12px;
      width: 1px;
      height: 15px;
      background-color: #e4e7ed;
      z-index: 1;
    }

    &:last-child:after {
      content: "";
      width: 0;
      height: 0;
    }
  }

  /deep/ .el-tabs__active-bar {
    height: 3px;
    background-color: #3686d7;
  }

  /deep/ .el-tabs__item.is-active {
    color: #3686d7;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }

  .orderSearchBox {
    display: flex;
    flex-wrap: wrap;
    .timeSearch {
      background-color: #f2f4f7;
      height: 35px;
      display: flex;
      align-items: center;
      margin-bottom: 22px;
      margin-right: 30px;
      border-radius: 8px;
      span {
        font-size: 12px;
        color: #c0c4cc !important;
        font-weight: normal;
        padding-left: 15px;
        margin-right: 5px;
      }
      // /deep/ .el-range-input{
      //         background-color: #f2f4f7;
      //             &:hover, &:focus {
      //             background-color: #fff;
      //             // border: 1px solid #108EE9;
      //         }
      // }
      /deep/input::-webkit-input-placeholder {
        color: #c0c4cc;
        font-size: 12px;
      }
      /deep/.el-range-input:hover {
        background-color: #fff !important;
      }
      /deep/ .el-date-editor .el-range-separator {
        line-height: 25px;
        color: #c0c4cc;
      }
      /deep/ .el-date-editor .el-range__close-icon {
        line-height: 28px;
      }
      /deep/ .el-input__inner:hover .el-range-input,
      /deep/ .el-input__inner:focus .el-range-input {
        background-color: white;
      }
      /deep/ .el-input__inner {
        width: 225px;
        height: 35px;
        min-height: 35px;
        font-size: 12px;
        color: #999999;
        background-color: #f2f4f7;
        border: 1px solid #f2f4f7;
        border-radius: 5px;
        .el-range-input {
          background-color: #f2f4f7;
        }

        &:hover,
        &:focus {
          background-color: #fff;
          border: 1px solid #108ee9;
        }
      }
      /deep/ .el-icon-date:before {
        content: "\E78E";
        display: none;
      }
      /deep/.el-input__icon {
        // display: none;
      }
    }
    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
      margin-bottom: 22px;
    }
  }

  .orderListTable {
    .orderNomesaage {
      color: #888;
      text-align: center;
      padding: 15px 0;
    }

    .tableHeader {
      display: flex;
      width: 100%;
      height: 35px;
      line-height: 35px;
      background: #f3f7ff;
      border-radius: 5px;
      margin: 0 0 15px;

      li {
        text-align: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .tableBody {
      li {
        width: 100%;
        border: 1px solid #f2f2f2;
        border-radius: 10px;
        margin-bottom: 16px;

        .itemTop {
          width: 100%;
          height: 42px;
          background: #ebf3fb;
          line-height: 42px;
          font-size: 14px;
          color: #333;
          padding: 0 20px;
          display: flex;
          align-items: center;
          position: relative;

          div {
            margin-right: 30px;
          }

          .merchantInfo {
            display: flex;
            align-items: center;

            i {
              color: #3d7fff;
              font-size: 25px;
              cursor: pointer;
              padding-left: 5px;
              display: block;
            }

            img {
              display: block;
              padding-right: 5px;
            }
          }

          .complainBtn {
            color: #999;
            position: absolute;
            right: 20px;
          }
        }

        .itemBottom {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 13px;

          .orderInfo {
            padding: 20px;
            display: flex;
            align-items: center;
            img {
              display: block;
              width: 100px;
              height: 100px;
              border-radius: 10px;
              margin-right: 30px;
            }

            .infoContent {
              width: 130px;
              .infoName {
                font-size: 14px;
                color: #000000;
                padding-bottom: 10px;
              }

              .infoOther {
                font-size: 13px;
                color: #999999;
                padding-bottom: 8px;
              }
            }
          }

          .arguments {
            padding: 20px;
          }

          .argumentsName {
            padding-bottom: 8px;
          }

          .payment {
            h3 {
              font-size: 14px;
              font-weight: 700;
              margin: 0;
            }

            .title {
              font-size: 12px;
              color: #999999;
            }
          }

          .status {
            font-size: 14px;
          }

          .operationBtn {
            display: block;
            color: #0c75d3;
            text-align: center;
            width: 100%;
            margin: 0;
          }

          .operationBtnMoney {
            color: #0c75d3;
            padding: 6px 20px;
            border: 1px solid #0c75d3;
            border-radius: 6px;
            margin-left: 10px;
            margin-top: 12px;

            &:nth-last-of-type(1) {
              margin-bottom: 12px;
            }
          }
        }
      }
    }
    .name {
      flex: 1;
      // white-space: nowrap;
    }
    .activeName {
      width: 15%;
      text-align: center;
    }

    .price {
      width: 13%;
      text-align: center;
    }

    .num {
      width: 13%;
      text-align: center;
    }

    .arguments {
      width: 10%;
    }

    .payment {
      width: 14%;
      text-align: center;
    }

    .status {
      width: 10%;
      text-align: center;
    }

    .operation {
      width: 10%;
      text-align: center;
    }
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
.evaluateDialogBox {
  .evaluateItem {
    .name {
      font-size: 14px;
      color: #000;
      padding-bottom: 20px;
      font-weight: bold;
    }

    .content {
      padding-left: 20px;
      padding-bottom: 15px;
    }

    .rateItem {
      display: flex;
      align-items: center;
      padding-bottom: 15px;

      .name {
        padding: 0 20px 0 0;
        font-size: 13px;
        color: #333;
        min-width: 100px;
        font-weight: normal;
      }
    }

    .evaluateTag {
      display: flex;
      flex-wrap: wrap;

      /deep/ .el-checkbox-button {
        display: block;
        margin-right: 20px;
        margin-bottom: 15px;
      }

      /deep/ .el-checkbox-button__inner {
        border: 1px solid #dcdfe6 !important;
        border-radius: 4px;
        padding: 8px 15px;
        font-size: 13px;
        box-shadow: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/integralOrderList.vue